module.exports = __webpack_public_path__ + "img/img_13.9caf906a.png";